<template>
  <div class="select-identity-dialog col-block width-full">
    <div class="select-identity-title-container col-block">
      <div class="select-identity-title">{{ $t('LAYOUT.dialog.selectIdentity.___title') }}</div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <hr>
    <div :style="{ height: '10px' }"></div>
    <div class="select-identity-option-list-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div class="select-identity-option-list-block" :class="isMobile ? ['col-block'] : ['row-block']">
        <div class="select-identity-option-container center-block" v-for="(option, soindex) in selectOptions" :key="soindex" @click="e => $emit('changeModal', {}, option.value)">
          <div class="select-identity-option-title" v-html="option.title"></div>
        </div>
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="select-identity-button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-outline-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import responsitive from '../../mixins/responsitive.vue'

export default {
  mixins: [
    responsitive
  ],
  computed: {
    // static
    selectOptions () {
      return [
        {
          title: this.$t('LAYOUT.dialog.selectIdentity.option.___patient'),
          value: 'patient'
        },
        {
          title: this.$t('LAYOUT.dialog.selectIdentity.option.___doctor'),
          value: 'doctor'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/selectIdentity.vue